module.exports = __webpack_public_path__ + "img/b.d5141d5d.jpg";